import { httpPatch } from 'utils/httpPatch';

interface IManagementFeeSettingResponse {
  userId: string;
  accountHolderId: number;
  monthlyFee?: number | null;
  annuallyFee?: number | null;
  paidDateTime?: string | null;
  paidAmount?: number | null;
  showModal: boolean;
  lockout: boolean;
  createdDateTime: string;
  updatedDateTime: string;
}

interface IManagementFeeSettingParams {
  monthlyFee?: number | null;
  annuallyFee?: number | null;
  paidAmount?: number | null;
  showModal?: boolean;
  lockout?: boolean;
}

export const updateManagementFeeStatus = async (params: IManagementFeeSettingParams) => {
  return httpPatch<IManagementFeeSettingResponse, IManagementFeeSettingParams>('portal/ManagementFeeSetting', params);
};
